'use strict';

module.exporst = spmv;

function spmv () {
  console.error('SPMV (symmetric packed matrix vector multiply) not yet implemented');
}
